export default {
  slices: [
    {
      field: 'ad_categories',
      display: 'Ad Category',
      map: {
        'market': {
          display: 'General Market',
          sortOrder: 1,
        },
        'hispanic': {
          display: 'Hispanic Market',
          sortOrder: 2
        }
      }
    },
    {
      field: 'ad_type',
      display: 'Ad Type',
      map: {
        'tv': {
          display: 'TV/CTV',
          sortOrder: 1
        },
        'social': {
          display: 'Digital',
          sortOrder: 2
        },
        'audio': {
          display: 'Audio',
          sortOrder: 3
        }        
      }
    }
  ]
};



// WEBPACK FOOTER //
// ./src/app/configuration/HEB/config/metadata.js